import { render } from "./RejectRequest.vue?vue&type=template&id=10ccf894"
import script from "./RejectRequest.vue?vue&type=script&lang=js"
export * from "./RejectRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__